module.exports = __webpack_public_path__ + "static/media/promotion_from_35_to_39.e05ea0ad.webp";